
<mat-grid-list cols="3" rowHeight="100px">

    
    <mat-grid-tile
        [colspan]=1
        [rowspan]=1>
            <a [routerLink]="['/securehome/contracts']">
                <font color="black" size="3">
                    <mat-icon>verified_user</mat-icon>
                    <br>
                    Contract
                </font>
            </a>
    </mat-grid-tile>


    <mat-grid-tile
        [colspan]=1
        [rowspan]=1>
            <a [routerLink]="['/securehome/people']">
                <font color="black" size="3">
                    <mat-icon>account_circle</mat-icon>
                    <br>
                    People
                </font>
            </a>
    </mat-grid-tile>

    <mat-grid-tile
        [colspan]=1
        [rowspan]=1>
        <a [routerLink]="['/securehome/parties']">
            <font color="black" size="3">
                <mat-icon>account_balance</mat-icon>
                <br>
                Parties
            </font>
        </a>
    </mat-grid-tile>

    <mat-grid-tile
        [colspan]=1
        [rowspan]=1>
        <a [routerLink]="['/securehome/baas']">
            <font color="black" size="3">
                <mat-icon>insert_link</mat-icon>
                <br>
                BAAs
            </font>
        </a>
    </mat-grid-tile>

</mat-grid-list>
      